@for (dateTime of times; track dateTime) {
  <div>
    <span>
      {{ dateTime.date | parseDateTime:'dddd MMM d' }}: {{ dateTime.time | parseDateTime: 'h:mma' }}
    </span>
  </div>
}